<div class="sg-alert sg-alert--{{ status }}" 
    [ngClass]="{'sg-alert--slideOut': alert.fadeOut}"
    >{{ alert.message }}<span class="sg-alert__close -{{ status }}"><mlp-ng-icon name="close" size="small"></mlp-ng-icon></span></div>